<template>
  <DefaultLayout>
    <div slot="content">
      <div class="d-flex align-center mb-3">
        <div class="title">System reports | Total requests from selected period: {{ filteredRequests.length }}</div>
        <v-spacer></v-spacer>
        <v-btn v-if="preparedRequests && preparedRequests.length && !loading" @click="exportToCSVBasic" text color="primary">Export basic activity to CSV</v-btn>
        <v-btn @click="getEmails" text color="primary">Get users email and date created</v-btn>
      </div>
      <v-divider></v-divider>
      <!-- FILTERS -->
      <v-row class="mt-1 mb-5">
        <v-col style="min-width: 120px;" class="py-0">
          <v-menu ref="fromDateMenu" :close-on-content-click="false" v-model="fromDateMenu" :return-value.sync="fromDate" transition="scale-transition" offset-y max-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-on="on" label="From" v-model="computedFromDate" readonly hide-details></v-text-field>
            </template>
            <v-date-picker v-model="fromDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn tile small text @click="fromDateMenu = false">Cancel</v-btn>
              <v-btn tile small dark depressed color="blue" @click="updateFromDate(fromDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col style="min-width: 120px;" class="py-0">
          <v-menu ref="toDateMenu" :close-on-content-click="false" v-model="toDateMenu" :return-value.sync="toDate" transition="scale-transition" offset-y max-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-on="on" label="To" v-model="computedToDate" readonly hide-details></v-text-field>
            </template>
            <v-date-picker v-model="toDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn tile small text @click="toDateMenu = false">Cancel</v-btn>
              <v-btn tile small dark depressed color="blue" @click="updateToDate(toDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row class="mt-1 mb-5">
        <v-col style="min-width: 120px;" class="py-0">
          <v-select
            v-model="selectedOrgs"
            :items="organizations"
            label="Accounts filter"
            item-text="name"
            item-value="id"
            multiple
            chips
            persistent-hint
            hide-details
            clearable
          ></v-select>
        </v-col>
      </v-row>
      <!-- END FILTERS -->
      <div v-if="preparedRequests && preparedRequests.length && !loading" style="min-height: 300px">
        <div class="d-flex align-center mb-3">
          <div class="subtitle">System activity (days, total)</div>
        </div>
        <ECharts :options="chartOptions0" autoresize />
      </div>

      <div v-if="preparedRequests && preparedRequests.length && !loading" style="min-height: 300px">
        <div class="d-flex align-center mb-3">
          <div class="subtitle">System activity (days, total, statuses)</div>
        </div>
        <ECharts :options="chartOptions" autoresize />
      </div>

      <v-row no-gutters v-if="preparedRequests && preparedRequests.length && !loading" >
        <v-col>
          <v-card class="pa-2" outlined tile>
            <div class="d-flex align-center mb-3">
              <div class="subtitle">Requests by status</div>
            </div>
            <ECharts :options="chartOptions3" autoresize />
          </v-card>
        </v-col>
        <v-col>
          <v-card class="pa-2" outlined tile >
            <div class="d-flex align-center mb-3">
              <div class="subtitle">Requests by account</div>
            </div>
            <ECharts :options="chartOptions2" autoresize />
          </v-card>
        </v-col>
      </v-row>

      <div v-if="loading" class="text-center pt-12 mt-12 headline">
          <v-progress-circular
            indeterminate
            color="blue-grey"
            width=2
            size=50></v-progress-circular>
      </div>
      <div v-if="!preparedRequests.length && !loading" class="text-center pt-12 mt-12 headline font-weight-bold grey--text">
        No requests match the currently applied filters
      </div>

      <div v-if="groupedRequests.length != 0" class="text-center mb-3 mt-3 subtitle font-weight-bold grey--text">
        * Data in table shows "requests number grouped by email address/total requests number"<br/>
        all colums marked with green are summ of all requests
      </div>

      <v-simple-table v-if="groupedRequests.length != 0">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Account name</th>
              <th class="text-left">Total Pending</th>
              <th class="text-left">Total (Pending, no data)</th>
              <th class="text-left">Total (Pending, with data)</th>
              <th class="text-left">Total Completed</th>
              <th class="text-left">Total Archived</th>
              <th class="text-left">Total In Purge Queue</th>
              <th class="text-left">Total Purged</th>
              <th class="text-left">Total Canceled</th>
              <th class="text-left">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in groupedRequests" :key="item">
              <td>{{ item[0].accountName }}</td>
              <td class="rowgreen">{{ totalPending(item) }}</td>
              <td>{{ totalNoData(item) }}</td>
              <td>{{ totalWithData(item) }}</td>
              <td class="rowgreen">{{ totalCompleted(item) }}</td>
              <td class="rowgreen">{{ totalArchived(item) }}</td>
              <td class="rowgreen">{{ totalPurge(item) }}</td>
              <td class="rowgreen">{{ totalPurged(item) }}</td>
              <td class="rowgreen">{{ totalCancel(item) }}</td>
              <td>{{ total(item) }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <br/>
      <br/>

      <div v-if="requestsRefs.length != 0" class="text-center mb-3 mt-3 subtitle font-weight-bold grey--text">
        * Data in table shows "requests number grouped by reference name"<br/>
        Table contains {{ requestsRefs.length }} unique references for selected accounts
        <br/><v-btn @click="exportToCSV" text color="primary">Export to CSV</v-btn>
      </div>

      <v-simple-table v-if="requestsRefs.length != 0">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Account name</th>
              <th class="text-left">Reference</th>
              <th class="text-left">Data requests</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in requestsRefs" :key="item">
              <td>{{ item.accountName }}</td>
              <td>{{ item.reference }}</td>
              <td>{{ item.count }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

    </div>
  </DefaultLayout>
</template>

<script>
import { mapState } from 'vuex';
import { CHECK_ORGANIZATIONS, GET_SYSTEM_ACTIVITY_REPORT_RECORDS,
  GET_SYSTEM_ACTIVITY_REPORT_RECORDS_REF,
  GET_ACTIVITY_REPORT_RECORDS,
  GENERATE_BASIC_DATA_REPORT,
  GET_USERS_EMAIL_DATE,
  GET_ORGANIZATIONS } from '@/store/actions.type';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/pie';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/polar'
import DefaultLayout from '@/layouts/DefaultLayout';

export default {
  name: 'reports',
  components: {
    DefaultLayout,
    ECharts,
  },
  data() {
    return {
      featureLimitedModal: false,
      featureLimitedText: '',
      featureLimitedDefaultText: 'To enable this feature, you need to upgrade your price plan.',
      privacyEmail: '',
      fromDateMenu: false,
      fromDate: null,
      toDateMenu: false,
      toDate: null,
      rModel: {
        pending: true,
        completed: true,
        archived: true,
        purge: true,
        purged: true,
        canceled: true,
      },
      requests: [],
      filteredRequests: [],
      headers: [
        { text: 'Status', value: 'status', align: 'left' },
        { text: 'Created', value: 'dateCreated', align: 'left' },
        { text: 'Requester', value: 'userName', align: 'left' },
        { text: 'Reference', value: 'reference', align: 'left' },
        { text: 'Client', value: 'clientName', align: 'left' },
      ],
      pagination: {
        sortBy: 'created',
      },
      users: [],
      chartOptions0: {},
      chartOptions: {},
      loading: true,
      basicDataModel: false,
      basicDataLoading: false,
      chartOptions2: {},
      chartOptions3: {},
      groupedRequests: [],
      organizations: [],
      selectedOrgs: [],
      rawRequests: [],
      rawRequestsRefs: [],
      requestsRefs: [],
    };
  },
  watch: {
    rModel: {
      handler: function() {
      },
      deep: true,
    },
    featureLimitedModal(val) {
      if (!val) {
        this.featureLimitedText = '';
      }
    },
    selectedOrgs(){
      this.filterOrgs();

      this.filteredRequests = this.requests;
      var groupBy = function(xs, key) {
        return xs.reduce(function(rv, x) {
          (rv[x[key]] = rv[x[key]] || []).push(x);
          return rv;
        }, {});
      };
      this.groupedRequests = groupBy(this.filteredRequests, 'accountName');
      this.updateChart();
    }
  },
  computed: {
    ...mapState({ organization: state => state.organizations.userSelectedOrganization }),
    ...mapState({ signedInUser: state => state.auth.account }),
    ...mapState({ limitations: state => state.organizations.userSelectedOrganization.limitations }),
    pendingCount() { return this.requests.filter(x => x.status === 1).length; },
    completedCount() { return this.requests.filter(x => x.status === 3).length; },
    archivedCount() { return this.requests.filter(x => x.status === 6).length; },
    purgeCount() { return this.requests.filter(x => x.status === 7).length; },
    purgedCount() { return this.requests.filter(x => x.status === 8).length; },
    canceledCount() { return this.requests.filter(x => x.status === 2).length; },
    computedFromDate() {
      return this.formatDate(this.fromDate);
    },
    computedToDate() {
      return this.formatDate(this.toDate);
    },
    updatedToDate() {
      const nextToDate = new Date(this.toDate);
      nextToDate.setDate(nextToDate.getDate() + 1);
      let dd = '' + nextToDate.getDate();
      let mm = '' + (nextToDate.getMonth() + 1);
      const yyyy = nextToDate.getFullYear();
      mm = mm.length < 2 ? '0' + mm : mm;
      dd = dd.length < 2 ? '0' + dd : dd;
      return [yyyy, mm, dd].join('-');
    },
    preparedRequests() {
      const requestsList = [];
      this.filteredRequests.forEach(request => {
        const requestItem = {
          status: request.status,
          created: request.created,
          account: request.accountName
        };
        requestsList.push(requestItem);
      });

      return requestsList;
    },
  },
  methods: {
    exportToCSV(){
      const rows = [];
      rows.push('Account name,Reference,Data requests');
      this.requestsRefs.forEach(request => {
        rows.push(`"${request.accountName}","${request.reference}","${request.count}"`);
      });
      this.saveCSV('references', rows);
    },
    exportToCSVBasic(){
      const all = [];
      all.push('Date,Requests');
      const dates = this.getDates(new Date(this.fromDate), new Date(this.updatedToDate));
      dates.forEach(dd => {
        const dateReq = this.filteredRequests.filter(x => x.createdISO === dd);
        if (!dateReq.length) {
          all.push(`"${dd}",0`);
          return;
        }
        all.push(`"${dd}",${dateReq.length}`);
      });
      this.saveCSV('requests', all);
    },
    async getEmails(){
      const response = await this.$store.dispatch(GET_USERS_EMAIL_DATE);
      const rows = [];
      rows.push('Email,DateCreated');
      response.forEach(request => {
        rows.push(`"${request.email}","${request.dateCreated}"`);
      });
      this.saveCSV('emailsDateCreated', rows);
    },
    filterOrgs(){
      if(this.selectedOrgs.length === 0){
        this.requests = this.rawRequests;
        this.requestsRefs = this.rawRequestsRefs;
        return;
      }
      this.requests = [];
      this.requestsRefs = [];

      this.rawRequests.forEach(rq => {
        if(this.selectedOrgs.includes(rq.accountId)){
          this.requests.push(rq);
        }
      });

      this.rawRequestsRefs.forEach(rq => {
        if(this.selectedOrgs.includes(rq.accountId)){
          this.requestsRefs.push(rq);
        }
      });
    },
    groupByy(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    totalPurged(item){
      return `${Object.keys(this.groupByy(item.filter(x => x.status === 8), 'email')).length}/${item.filter(x => x.status === 8).length}`;
    },
    totalPurge(item){
      return `${Object.keys(this.groupByy(item.filter(x => x.status === 7), 'email')).length}/${item.filter(x => x.status === 7).length}`;
    },
    totalCompleted(item){
      return `${Object.keys(this.groupByy(item.filter(x => x.status === 3), 'email')).length}/${item.filter(x => x.status === 3).length}`;
    },
    totalPending(item){
      return `${Object.keys(this.groupByy(item.filter(x => x.status === 1), 'email')).length}/${item.filter(x => x.status === 1).length}`;
    },
    totalArchived(item){
      return `${Object.keys(this.groupByy(item.filter(x => x.status === 6), 'email')).length}/${item.filter(x => x.status === 6).length}`;
    },
    totalWithData(item){
      return `${Object.keys(this.groupByy(item.filter(x => x.filled > 0 && x.status === 1), 'email')).length}/${item.filter(x => x.filled > 0 && x.status === 1).length}`;
    },
    totalNoData(item){
      return `${Object.keys(this.groupByy(item.filter(x => x.filled === 0 && x.status === 1), 'email')).length}/${item.filter(x => x.filled === 0 && x.status === 1).length}`;
    },
    totalCancel(item){
      return `${Object.keys(this.groupByy(item.filter(x => x.filled === 0 && x.status === 2), 'email')).length}/${item.filter(x => x.filled === 0 && x.status === 2).length}`;
    },
    total(item){
      return `${Object.keys(this.groupByy(item, 'email')).length}/${item.length}`;
    },
    formatDate(date) {
      // format date from 2019-09-18 to 18/09/2019
      if (!date) return null;
      const splitDate = date.split('-');
      return `${splitDate[2]}/${splitDate[1]}/${splitDate[0]}`;
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    async fetchRequests() {
      this.loading = true
      const data = {
        from: this.fromDate,
        to: this.updatedToDate,
      };

      const response = await this.$store.dispatch(GET_SYSTEM_ACTIVITY_REPORT_RECORDS, data);
      this.rawRequestsRefs = await this.$store.dispatch(GET_SYSTEM_ACTIVITY_REPORT_RECORDS_REF, data);

      response.forEach(request => {
        request.created = new Date(request.created);
        request.createdISO = request.created.toISOString().split("T")[0];
      });

      this.rawRequests = response;
      this.filterOrgs();
      this.loading = false

      this.filteredRequests = this.requests;

      var groupBy = function(xs, key) {
        return xs.reduce(function(rv, x) {
          (rv[x[key]] = rv[x[key]] || []).push(x);
          return rv;
        }, {});
      };

      this.groupedRequests = groupBy(this.filteredRequests, 'accountName');
      this.updateChart();
    },
    updateChart() {
      const ech = [['Date', 'Pending', 'Completed', 'Archived', 'Purge', 'Purged', 'Canceled']];
      const all = [['Date', 'Requests']];

      const dates = this.getDates(new Date(this.fromDate), new Date(this.updatedToDate));
      dates.forEach(dd => {
        const dateReq = this.filteredRequests.filter(x => x.createdISO === dd);
        if (!dateReq.length) {
          ech.push([dd, 0, 0, 0, 0, 0, 0]);
          all.push([dd, 0]);
          return;
        }
        ech.push([
          dd,
          dateReq.filter(x => x.status == 1).length,
          dateReq.filter(x => x.status == 3).length,
          dateReq.filter(x => x.status == 6).length,
          dateReq.filter(x => x.status == 7).length,
          dateReq.filter(x => x.status == 8).length,
          dateReq.filter(x => x.status == 2).length,
        ]);
        all.push([
          dd,
          dateReq.length,
        ]);
      });

      this.chartOptions0 = {
        color: ['#97D8C4', '#7D4600', '#F58F29', '#A4B0F5', '#B74F6F'],
        dataset: {
          source: all,
        },
        xAxis: {
          type: 'time',
          splitLine: { show: true, lineStyle:{type:'dashed'}},
          axisLine: {lineStyle: {color: '#BDBDBD'}},
          axisLabel: {color: '#BDBDBD'},
          boundaryGap: false
        },
        yAxis: {
          type : 'value',
          splitLine: { show: true, lineStyle:{type:'dashed'}},
          axisLine: {lineStyle: {color: '#BDBDBD'}},
          axisLabel: {color: '#BDBDBD'},
          boundaryGap: [0, '100%']
        },
        series:  [
          {type: 'line', stack: 'ccc', areaStyle: {}, smooth: true},
        ],
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 20
          },
          {
            start: 0,
            end: 20
          }
        ],
        grid: {
          top: '5%',
          left: '1%',
          right: '1%',
          bottom: '5%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            restore: {},
            saveAsImage: {}
          }
        },
      };

      const polar = {
        color: ['#F4B942', '#97D8C4', '#7D4600', '#F58F29', '#A4B0F5', '#B74F6F'],
        dataset: {
          source: ech,
        },
        xAxis: {
          type: 'category',
          splitLine: { show: true, lineStyle:{type:'dashed'}},
          axisLine: {lineStyle: {color: '#BDBDBD'}},
          axisLabel: {color: '#BDBDBD'},
        },
        yAxis: {
          type : 'value',
          splitLine: { show: true, lineStyle:{type:'dashed'}},
          axisLine: {lineStyle: {color: '#BDBDBD'}},
          axisLabel: {color: '#BDBDBD'},
        },
        series:  [
          {type: 'bar', stack: 'ccc'},
          {type: 'bar', stack: 'ccc'},
          {type: 'bar', stack: 'ccc'},
          {type: 'bar', stack: 'ccc'},
          {type: 'bar', stack: 'ccc'},
          {type: 'bar', stack: 'ccc'},
        ],
        grid: {
          top: '5%',
          left: '1%',
          right: '1%',
          bottom: '5%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
      };
      this.chartOptions = polar;

      let data = this.getPieData1()

      this.chartOptions2 = {
          title: {
              text: 'title text',
              subtext: 'title subtext',
              left: 'center'
          },
          tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
              type: 'scroll',
              orient: 'vertical',
              right: 10,
              top: 20,
              bottom: 20,
              data: data.legendData,
              selected: data.selected
          },
          series: [
              {
                  name: 'Series name',
                  type: 'pie',
                  radius: '70%',
                  center: ['50%', '50%'],
                  data: data.seriesData,
                  emphasis: {
                      itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                      }
                  }
              }
          ]
      };

      let data2 = this.getPieData2()

      this.chartOptions3 = {
          title: {
              text: 'title text',
              subtext: 'title subtext',
              left: 'center'
          },
          tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
              type: 'scroll',
              orient: 'vertical',
              right: 10,
              top: 20,
              bottom: 20,
              data: data2.legendData,
              selected: data2.selected
          },
          series: [
              {
                  name: 'Series name',
                  type: 'pie',
                  radius: '70%',
                  center: ['50%', '50%'],
                  data: data2.seriesData,
                  emphasis: {
                      itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                      }
                  }
              }
          ]
      };
    },
    getPieData1(){
      const grouped = this.groupBy(this.filteredRequests, req => req.accountName);
      var nameList = [];
      var legendData = [];
      var seriesData = [];
      var selected = {};
      Array.from(grouped).forEach(acc => {
        nameList.push(acc[0]);
        legendData.push(acc[0]);
        seriesData.push({
            name: acc[0],
            value: acc[1].length
        });
        selected[acc[0]] = true;
      });
      return {
          legendData: legendData,
          seriesData: seriesData,
          selected: selected
      };
    },
    getPieData2(){
      const grouped = this.groupBy(this.filteredRequests, req => req.status);
      var nameList = [];
      var legendData = [];
      var seriesData = [];
      var selected = {};
      Array.from(grouped).forEach(acc => {
        let name = this.getStatusName(acc[0])
        nameList.push(name);
        legendData.push(name);
        seriesData.push({
            name: name,
            value: acc[1].length
        });
        selected[name] = true;
      });
      return {
          legendData: legendData,
          seriesData: seriesData,
          selected: selected
      };
    },
    getStatusName(s){
      if(s === 1){
        return 'Pending'
      }
      if(s === 2){
        return 'Cancelled'
      }
      if(s === 3){
        return 'Completed'
      }
      if(s === 4){
        return 'Revoked'
      }
      if(s === 5){
        return 'Deleted'
      }
      if(s === 6){
        return 'Archived'
      }
      if(s === 7){
        return 'Purge'
      }
      if(s === 8){
        return 'Purged'
      }
      if(s === 9){
        return 'Rejected'
      }
      if(s === 10){
        return 'Accepted'
      }
      if(s === 11){
        return 'Expired'
      }
      if(s === 12){
        return 'PurgeRequested'
      }
      return ''
    },
    getDates(startDate, endDate) {
      const dates = [];
      let currentDate = startDate;
      const addDays = function(days) {
        const date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };
      while (currentDate <= endDate) {
        dates.push(currentDate.toISOString().split('T')[0]);
        currentDate = addDays.call(currentDate, 1);
      }
      return dates;
    },
    getDate(dateTime) {
      const formattedDate = new Date(dateTime).toLocaleString('en-GB', { timeZone: 'UTC' });
      return formattedDate;
    },
    updateFromDate(date) {
      this.$refs.fromDateMenu.save(date);
      this.fetchRequests();
    },
    updateToDate(date) {
      this.$refs.toDateMenu.save(date);
      this.fetchRequests();
    },
    groupBy(list, keyGetter) {
        const map = new Map();
        list.forEach((item) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return map;
    },
    saveCSV(name, rowsArray) {
      if (!name) {
        name = 'output.csv';
      } else {
        name += '.csv'
      }
      let csvContent = '';
      rowsArray.forEach(row => {
        csvContent += row + '\r\n';
      });
      const blob = new Blob( [ csvContent ], { type: 'text/csv'} );
      const link = document.body.appendChild(document.createElement('a'));

      if (navigator.msSaveOrOpenBlob) {
        // Works for Internet Explorer and Microsoft Edge
        navigator.msSaveOrOpenBlob(blob, name);
      } else if ('download' in link) {
        // Attempt to use an alternative method
        link.href = URL.createObjectURL(blob);
        link.download = name;
        link.click();
      } else {
        this.$notify({
          type: 'error',
          title: 'Error!',
          text: 'Your browser doesn\'t allow to export csv files. ',
        });
      }
    },
  },
  async mounted() {
    try {
      const response = await this.$store.dispatch(GET_ORGANIZATIONS);
      this.organizations = response.sort((a, b) => a.name.localeCompare(b.name));
    } catch(err) {
      this.$notify({
        type: 'error',
        title: 'Error',
        text: 'Error getting organizations. Please contact support@planetverify.com',
      });
    }
  },
};
</script>

<style>
.echarts {
  width: 100%;
  /* height: 100%;
  min-height: 300px; */
}
.theme--light.v-card.v-card--outlined {
    border: 0 !important;
}

.rowgreen {
  background-color: #AEFFBD;
}
.rowred {
  background-color: #FF9191;
}
</style>
